import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { CommentsCommentFragment } from 'generated/resources/graphql'

import { MentionedAccess } from 'modules/core/components/TextEditor/plugins/DebouncedMentionsPlugin'
import { Result, UnhandledResult } from 'modules/core/lib/handleMutation'

import CommentsContainer from 'modules/comments/components/CommentsContainer'
import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'

interface Props {
  comments: CommentsCommentFragment[]
  onAddComment: (
    variables: CommentsCommentValues
  ) => Promise<UnhandledResult<Result<Omit<unknown, 'errors'>>>>
  resourceId: number
  onFetchCustomMentionableAccesses?: (queryString: string) => Promise<MentionedAccess[]> | undefined
}

const EDITOR_OFFSET = 110

const SidepanelComments = ({
  comments,
  resourceId,
  onAddComment,
  onFetchCustomMentionableAccesses,
}: Props) => {
  return (
    <Box
      style={{
        height: `calc(100vh - ${EDITOR_OFFSET}px)`,
      }}
    >
      <CommentsContainer
        totalCount={comments.length}
        comments={comments}
        onAddComment={onAddComment}
        resourceId={resourceId}
        onFetchCustomMentionableAccesses={onFetchCustomMentionableAccesses}
      />
    </Box>
  )
}

export default SidepanelComments
